/**
 * Formata uma data ISO 8601 para exibição em pt-BR. Local a este
 * módulo (não `shared-utils`) porque nenhuma outra tela do frontend
 * ainda precisou formatar data para exibição — `formatBRL`/
 * `centavosParaReais` (moeda) continuam vindo de
 * `@pgcustom/shared-utils`, reaproveitados sem alteração.
 */
export function formatarDataHora(iso: string): string {
  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(iso));
}
